export const baseType2Icons = {
  info: 'tip',
  success: 'success-circle',
  error: 'error-circle',
  warning: 'warning',
};

export default {};
